export default __webpack_public_path__ + "static/media/UNAMID_deputy_JSR-protection_visits_sortony_north_darfur.212b2d20.jpg";